import { useState } from 'react';
import {
  generateProblem,
  getCorrectAnswer,
  calculatePoints,
  getRandomEncouragingMessage,
  getRandomTryAgainMessage,
  checkAchievements,
} from '../utils/gameUtils';
import { TIMINGS, LEVEL_UP_STREAK } from '../config/gameConfig';

/**
 * Custom hook to manage math problems and answer checking
 */
export function useProblemGenerator(difficulty, selectedOperations, gameActions, trackProblem = null) {
  const [currentProblem, setCurrentProblem] = useState({
    num1: 0,
    num2: 0,
    operator: '+',
  });
  const [userAnswer, setUserAnswer] = useState('');
  const [feedback, setFeedback] = useState('');
  const [showCelebration, setShowCelebration] = useState(false);

  const generateNewProblem = () => {
    const problem = generateProblem(difficulty, selectedOperations);
    setCurrentProblem(problem);
    return problem;
  };

  const checkAnswer = (streak, level, lives) => {
    const correctAnswer = getCorrectAnswer(currentProblem);
    const userNum = parseInt(userAnswer);
    const isCorrect = userNum === correctAnswer;

    // Track the problem attempt
    if (trackProblem) {
      // Determine operation type from operator
      let operationType = 'plus';
      if (currentProblem.operator === '-') operationType = 'minus';
      else if (currentProblem.operator === '×') operationType = 'gange';

      trackProblem({
        problem: `${currentProblem.num1} ${currentProblem.operator} ${currentProblem.num2}`,
        correctAnswer,
        userAnswer: userNum,
        isCorrect,
        operationType,
        difficulty,
        level,
        streak,
      });
    }

    if (isCorrect) {
      // Correct answer
      const points = calculatePoints(difficulty, streak);
      gameActions.addScore(points);
      gameActions.incrementStreak();

      setFeedback(getRandomEncouragingMessage());
      setShowCelebration(true);

      // Check for achievements
      const newStreak = streak + 1;
      const achievements = checkAchievements(newStreak, level);

      achievements.forEach((achievement) => {
        gameActions.addAchievement(achievement);
      });

      // Level up check
      if (newStreak % LEVEL_UP_STREAK === 0) {
        gameActions.levelUp();
      }

      setTimeout(() => {
        generateNewProblem();
        setUserAnswer('');
        setFeedback('');
        setShowCelebration(false);
      }, TIMINGS.CELEBRATION_DURATION);

      return true;
    } else {
      // Wrong answer
      gameActions.resetStreak();
      const newLives = gameActions.loseLife();

      setFeedback(getRandomTryAgainMessage());

      if (newLives <= 0) {
        // Game over
        gameActions.endGame();
      }

      return false;
    }
  };

  return {
    currentProblem,
    userAnswer,
    setUserAnswer,
    feedback,
    showCelebration,
    generateNewProblem,
    checkAnswer,
  };
}
